module.exports = __webpack_public_path__ + "7d4bf240e4299f79ebe37f2c100e96d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-ringlets-black-s.png
// module id = 2844
// module chunks = 0